'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Quiz = void 0;
const $ = require("jquery");
const ajax_1 = require("./ajax");
class Quiz {
    constructor() {
        this.ajax = new ajax_1.default();
        if ($('.daily-quiz').length) {
            this.initDailyQuiz();
        }
    }
    initDailyQuiz() {
        const quizData = window.quizData;
        if (!quizData)
            return;
        const correct = quizData.correct;
        const postId = quizData.post_id;
        const nonce = quizData.nonce;
        const viewCount = quizData.view_count ?? 0;
        const correctCount = quizData.correct_count ?? 0;
        const $quiz = $('.daily-quiz');
        const $explanation = $('.daily-quiz-explanation');
        const $comment = $('.mishika-comment');
        const $actions = $('.daily-quiz-page__actions');
        const $judge = $('.daily-quiz__judge');
        // 正解率を表示
        if (viewCount > 0) {
            const rate = Math.round(correctCount / viewCount * 100);
            $('.daily-quiz__correct-rate').text(`正解率: ${rate}%`);
        }
        // 選択肢クリック
        $quiz.on('click', '.daily-quiz__choice', (e) => {
            // 二重クリック防止
            if ($quiz.attr('data-answered') === 'true')
                return;
            $quiz.attr('data-answered', 'true');
            const $choice = $(e.currentTarget);
            const choiceIndex = parseInt($choice.attr('data-index') || '0', 10);
            const isCorrect = choiceIndex === correct;
            // 選択済みスタイル
            $choice.attr('data-is-selected', 'true');
            // 正誤表示
            $judge.attr('data-judge', isCorrect ? 'correct' : 'incorrect');
            // AJAX保存
            this.ajax.saveAnswer(postId, isCorrect, nonce).always(() => {
                // 正誤問わず解説・コメント・ボタンを表示
                setTimeout(() => {
                    $quiz.attr('hidden', '');
                    $explanation.removeAttr('hidden');
                    $comment.removeAttr('hidden');
                    $actions.removeAttr('hidden');
                }, 800);
            });
        });
    }
}
exports.Quiz = Quiz;
exports.default = Quiz;
